import React, {Component} from 'react';

import {connect} from '@stubhub/react-store-provider';

import Message from '../react-page-status';

import * as controller from './controller';

import './index.scss';

@connect(controller)
class Alert extends Component {
  static propTypes = {};

  render() {
    return (
      <React.Fragment>
        {this.props.errors && this.props.errors.length > 0 && (
          <Message
            text={this.props.errors[0]}
            type="error"
            manualClickable={true}
            onClose={this.props.onCloseError.bind(this, 0)}
          />
        )}
        {this.props.msgs && this.props.msgs.length > 0 && (
          <Message text={this.props.msgs[0]} type="success" onClose={this.props.onCloseSuccess.bind(this, 0)} />
        )}
      </React.Fragment>
    );
  }
}

export default Alert;
